import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useSupabase } from '@/hooks/useSupabase'

export default function Dashboard() {
  const db = useSupabase()
  const [stats, setStats] = useState({ clientes: 0, servicios: 0, cotizaciones: 0, perfiles: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    (async () => {
      try {
        const [c, s, q, p] = await Promise.all([
          db.count('clientes'), db.count('servicios'), db.count('cotizaciones'), db.count('perfiles_equipo'),
        ])
        setStats({ clientes: c, servicios: s, cotizaciones: q, perfiles: p })
      } catch { /* silent */ }
      finally { setLoading(false) }
    })()
  }, [])

  const cards = [
    { label: 'Clientes', value: stats.clientes, color: 'info', to: '/clientes', icon: '👥' },
    { label: 'Servicios', value: stats.servicios, color: 'success', to: '/servicios', icon: '📦' },
    { label: 'Cotizaciones', value: stats.cotizaciones, color: 'warning', to: '/cotizaciones', icon: '📄' },
    { label: 'Perfiles', value: stats.perfiles, color: '', to: '/perfiles', icon: '🧑‍💻' },
  ]

  return (
    <div className="page-enter">
      <div className="page-header">
        <div><h1>Dashboard</h1><p className="page-subtitle">Resumen general del sistema de cotizaciones</p></div>
        <Link to="/cotizaciones/nueva" className="btn btn-primary">+ Nueva Cotización</Link>
      </div>

      <div className="stats-grid">
        {cards.map(c => (
          <Link key={c.label} to={c.to} style={{ textDecoration: 'none' }}>
            <div className="stat-card">
              <div className="stat-label">{c.icon} {c.label}</div>
              <div className={`stat-value ${c.color}`}>{loading ? '—' : c.value}</div>
            </div>
          </Link>
        ))}
      </div>

      <div className="card">
        <div className="card-header"><h2>Acciones Rápidas</h2></div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Link to="/cotizaciones/nueva" className="btn btn-primary">📄 Nueva Cotización</Link>
          <Link to="/equipo/nueva" className="btn btn-secondary">👥 Equipo Dedicado</Link>
          <Link to="/clientes" className="btn btn-secondary">➕ Gestionar Clientes</Link>
          <Link to="/configuracion" className="btn btn-secondary">⚙️ Configuración</Link>
        </div>
      </div>
    </div>
  )
}
